import { createContext } from 'react';
import type { NostrUser } from '../hooks/useCurrentUser';

export interface AppContextType {
  user: NostrUser | null;
  login: () => Promise<void>;
  loginWithExtension: () => Promise<void>;
  loginWithNsec: (nsec: string) => Promise<void>;
  loginWithBunker: (bunkerUrl: string, onProgress?: (msg: string) => void) => Promise<void>;
  logout: () => void;
  updateProfile: (p: Partial<NostrUser>) => void;
  switchToBusiness: (businessPubkey: string) => void;
  switchToPersonal: () => void;
  showLoginDialog: boolean;
  setShowLoginDialog: (show: boolean) => void;
  /** An encrypted nsec is stored but locked — the app should prompt for a PIN. */
  nsecLocked: boolean;
  /** The pubkey of the locked account (for showing whose profile to unlock). */
  lockedPubkey: string | null;
  /** Unlock the encrypted nsec with the PIN. Rejects on a wrong PIN. */
  unlockWithPin: (pin: string) => Promise<void>;
  theme: 'light' | 'dark';
  toggleTheme: () => void;
  mutedPubkeys: Set<string>;
  mute: (p: string) => void;
  unmute: (p: string) => void;
  isMuted: (p: string) => boolean;
}

export const AppContext = createContext<AppContextType | null>(null);

